let embedded: boolean | undefined;

/**
 * Which runtime this frontend is in. Discord loads an Activity with
 * `frame_id` (plus instance_id/platform) in the query string; a plain browser
 * tab (the "open in browser" mode) has none. Read ONCE and latched: a later
 * in-Activity URL change (router / replaceState dropping `frame_id`) must never
 * flip API calls to absolute URLs, which Discord's CSP would block.
 */
export function isEmbeddedInDiscord(): boolean {
  embedded ??= new URLSearchParams(window.location.search).has("frame_id");
  return embedded;
}

/** Test-only: forget the latched mode so a test can change location.search. */
export function __resetRuntimeModeForTests(): void {
  embedded = undefined;
}

/**
 * Resolve an `/api/...` path for the current runtime. Inside Discord, relative
 * paths are routed by the Activity's URL mapping (+ patchUrlMappings), exactly
 * as before. In a plain browser the static site has no /api, so prefix the
 * backend base URL (CORS is open on the backend; auth is a bearer header).
 */
export function apiUrl(path: string): string {
  if (isEmbeddedInDiscord()) return path;
  const base = ((import.meta.env.VITE_BACKEND_BASE_URL as string | undefined) ?? "").replace(/\/+$/, "");
  return base ? `${base}${path}` : path;
}
